export default __webpack_public_path__ + "static/media/borg_scale.3a778d50.png";